<template>
    <CardRh :processando="processando" v-if="matricula" titulo="Cuidado! Insercao de falta em lote">
        <div class="matricula-falta-lote-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span> 
                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pesquisaFaltaLoteMatricula" class="form-label">Pesquisar</label>
                        <input id="pesquisaFaltaLoteMatricula" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Disciplina, instrutor ou numero" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMinFaltaLoteMatricula" class="form-label">Data Minima</label>
                        <input id="dataMinFaltaLoteMatricula" v-model="data_min" @keyup="apertouEnter"
                            @blur="refreshTable" type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="dataMaxFaltaLoteMatricula" class="form-label">Data Maxima</label>
                        <input id="dataMaxFaltaLoteMatricula" v-model="data_max" @keyup="apertouEnter"
                            @blur="refreshTable" type="date" class="form-control form-control-solid" />
                    </div> 
                    <div class="col-12 col-md-6 col-lg-2" v-if="motivos_select">
                        <label for="motivoFaltaLoteMatricula" class="form-label">Motivo</label>
                        <Multiselect id="motivoFaltaLoteMatricula" :options="motivos_select" :searchable="true"
                            v-model="FaltaMotivo" />
                    </div> 
                    <div class="col-12 col-lg-3 panel-actions mt-10"> 
                        <button type="button" class="btn btn-pmes-primary btn-sm" v-if="data_max && data_min && FaltaMotivo" @click="salvarLote">
                            Inserir
                        </button>
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                    </div> 
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                    <th style="max-width:80px">Id</th>
                    <th style="max-width:80px">N</th>
                    <th>Disciplina</th>
                    <th>Pel</th>
                    <th>Data</th>
                    <th>Instrutor</th>
                    <th>Situacao</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CardRh from "@/components/cards/ManzaCard.vue";
import AulaService from "@/service/v1/sigap/AulaService";
import FaltaService from "@/service/v1/sigap/FaltaService";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import Multiselect from "@vueform/multiselect";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import { Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
const authStore = namespace("auth");
import BotaoSalvar from "@/components/aplicacao/BotaoSalvar.vue";

@Options({
    name: "FaltaLoteIndex",
    components: { CardRh, KDataTable, Multiselect, BotaoSalvar },
})
export default class FaltaLoteIndex extends Vue {
    @Prop() readonly matricula!: any;

    @authStore.Getter
    public perfis!: any;

    public faltaService = new FaltaService();
    public FaltaMotivo = null;
    public motivos: any = [];
    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;
    public data_min: any = null;
    public data_max: any = null;
    public meses = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    public dias = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
    public search = "";

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.data_min = null;
        this.data_max = null;
        this.FaltaMotivo = null;
        this.refreshTable();
    }

    get hj() {
        return new Date().getFullYear() + "-" + this.meses[new Date().getMonth()] + "-" + this.dias[new Date().getDate()];
    }

    get motivos_select() {
        return this.motivos.map((item) => {
            return { value: item.id, label: item.nome.replaceAll("_", " ") };
        });
    }

    public buscarFaltaMotivos() {
        this.faltaService.getMotivo()
            .then(response => {
                this.motivos = response;
            });
    }

    protected salvarLote() {
        SiteUtils.alertConfimacao("Confirma a Insercao de todas as faltas? ", "",
            () => {
                this.salvar();
            }
        );
    }

    public salvar() {
        if (this.processando || !this.hasPermissao) { return; }
        this.processando = true;
        const dados = {
            MatriculaId: this.matricula.id,
            FaltaMotivo: this.FaltaMotivo,
            DataMin: this.data_min,
            DataMax: this.data_max,
        };
        setTimeout(() => {
            this.faltaService.cadastrarLote(dados)
                .then(response => {
                    SiteUtils.toastSucesso("Falta adicionada com successo.! ", response.message);
                    this.processando = false;
                })
                .catch(error => {
                    this.processando = false;
                    SiteUtils.toastErro("Error! ", error.data.message);
                });
        }, 100);
    }

    created() {
        this.buscarFaltaMotivos();
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.data_min = this.hj;
        this.service = new AulaService();
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    DataMin: this.data_min,
                    DataMax: this.data_max,
                    pelotao: this.matricula.pelotao,
                    turmaId: this.matricula.turmaId,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[4, 'desc'],[1, 'desc']];
        this.config.columns = [
            { data: "id", name: "id", searchable: false },
            { data: "numero", name: "numero", class: "desktop", searchable: false },
            { data: "disciplina", name: "disciplina", searchable: false },
            { data: "aulaDisciplina", name: "auladisciplina", searchable: false , orderable: false},
            { data: "data", name: "data", class: "desktop", searchable: false },
            { data: "instrutor", name: "instrutor", class: "desktop", searchable: false },
            { data: "status", name: "status", searchable: false, class: "text-center desktop" },
        ];

        this.config.columnDefs = [
            {
                targets: 1,
                render: (row, type, val) => {
                    return row + "/" + val.disciplina.cargaHoraria;
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return row != null ? row.descricao : "";
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return row != null ? row.pelotao : "";
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 5,
                render: (row) => {
                    return row != null ? row.nome : "";
                }
            },
            {
                targets: 6,
                render: (row) => {
                    return row.nome ?? "";
                }
            },
        ];
    }
}
</script>

<style scoped>
.matricula-falta-lote-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.panel-submit {
    display: flex;
    justify-content: flex-end;
    margin-top: 4px;
}

.btn-sm {
    margin-left: 10px;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }

    .panel-submit {
        justify-content: flex-start;
    }
}
</style>

<style>
.multiselect-search {
    background: #F5F8FA !important;
}
</style>
